<template>
  <div ref="container">
    <b-overlay :show="dataLoading" spinner-variant="primary" variants="white" opacity="0.6">
      <vs-table :data="results" stripe class="report-table mb-base mb-2">
        <template slot="thead">
          <vs-th v-for="(column, columnIndex) in columns" :key="columnIndex" class="text-left">
            <span :class="{ 'cursor-default' : column.disableOrderBy}" @click="manageOrder(column)">
              {{ column.displayName }}
              <em
                v-if="isOrderByThisColumnActive(column.name)"
                class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
              >{{ getArrowUpOrDown() }}</em>
            </span>
          </vs-th>
        </template>

        <template v-slot="{data}">
          <vs-tr v-for="(tr, indextr) in data" :key="indextr">
            <vs-td
              v-for="(column, columnIndex) in columns"
              :key="columnIndex"
              :data="data[indextr][column.name]"
              :class="column.class"
            >
              {{ data[indextr][column.name] }}{{ column.unit ? column.unit : '' }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </b-overlay>
    <vs-row>
      <vs-col vs-w="2" class="text-left">
        <vs-button @click="getFile()">
          {{ download }}
        </vs-button>
      </vs-col>
      <vs-col vs-w="10" class="text-right">
        <vs-pagination v-model="page" :total="totalPages" :max="9" color="primary" />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import store from '@/store'
import moment from 'moment'

export default {
  name: 'SearchProducts',
  props: [
    'type', 'startDate', 'endDate', 'download',
  ],
  data() {
    return {
      columns: [
        {
          displayName: this.$t('search.searchProducts.productId'),
          name: 'product_id',
          class: 'text-left',
        },
        {
          displayName: this.$t('search.searchProducts.productName'),
          name: 'product_name',
          disableOrderBy: true,
          class: 'text-left',
        },
        {
          displayName: this.$t('search.searchProducts.clicks'),
          name: 'clicks',
          class: 'text-right',
        },
        {
          displayName: this.$t('search.searchProducts.conversion'),
          name: 'sales_conversion',
          class: 'text-right',
          unit: '%',
        },
        {
          displayName: this.$t('search.searchProducts.salesCount'),
          name: 'sales_count',
          class: 'text-right',
        },
        {
          displayName: this.$t('search.searchProducts.salesUnitsSold'),
          name: 'sales_units_sold',
          class: 'text-right',
        },
        {
          displayName: this.$t('search.searchProducts.salesTotal'),
          name: 'sales_total',
          class: 'text-right whitespace-no-wrap',
          unit: ' zł',
        },
      ],
      defaultSort: 'desc',
      page: 1,
      sort: this.defaultSort,
      orderBy: 'sales_conversion',
    }
  },
  computed: {
    dataLoading() {
      return store.state.searchProductReport.dataLoading
    },
    results() {
      return store.state.searchProductReport.results
    },
    totalPages() {
      return store.state.searchProductReport.totalPages ?? 1
    },
  },
  watch: {
    startDate() {
      this.getData()
    },
    endDate() {
      this.getData()
    },
    type() {
      this.getData()
    },
    page() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    isOrderByThisColumnActive(columnName) {
      return this.orderBy === columnName
    },
    getArrowUpOrDown() {
      return this.sort === 'asc' ? 'expand_less' : 'expand_more'
    },
    manageOrder(column) {
      if (typeof column.disableOrderBy !== 'undefined' && column.disableOrderBy) {
        return
      }
      if (this.orderBy === column.name) {
        if (this.sort === 'asc') {
          this.sort = 'desc'
        } else {
          this.sort = 'asc'
        }
        this.getData()
        return
      }
      this.orderBy = column.name
      this.sort = this.defaultSort

      this.getData()
    },
    formatStartDate(date) {
      return moment(date).format('YYYY-MM-DD 00:00:00')
    },
    formatEndDate(date) {
      return moment(date).format('YYYY-MM-DD 23:59:59')
    },

    getFile() {
      const requestData = {
        type: this.type,
        start: this.formatStartDate(this.startDate),
        end: this.formatEndDate(this.endDate),
        sort: this.sort,
        orderBy: this.orderBy,
      }
      store.dispatch('searchProductReport/getFile', requestData)
    },
    getData() {
      const requestData = {
        type: this.type,
        start: this.formatStartDate(this.startDate),
        end: this.formatEndDate(this.endDate),
        page: this.page,
        sort: this.sort,
        orderBy: this.orderBy,
      }
      store.dispatch('searchProductReport/getData', requestData)
    },
  },
}
</script>

<style>
.vs-table--tbody {
  z-index: auto;
}

.vs-table--thead {
  z-index: auto;
}

.vs-pagination--ul {
  margin-bottom: 0;
}

.vs-pagination--li {
  width: auto;
  min-width: 35px;
}

.vs-pagination--li.is-current {
  padding-left: 3px;
  padding-right: 5px;
  min-width: 35px;
  border-radius: 35px;
}

.vs-pagination--li.is-current .effect {
  border-radius: 35px;
}
</style>
